import $ from "jquery";
import { Swiper } from "swiper";
import { Autoplay, EffectFade, Navigation } from "swiper/modules";
import "swiper/scss";
import "swiper/scss/navigation";
import "swiper/scss/effect-fade";
import gsap from "gsap";

$(".js-fade-slider").each(function () {
  const prevButton = this.querySelector(".slider-navigation .slider--prev");
  const nextButton = this.querySelector(".slider-navigation .slider--next");

  const enableAutoplay = $(this).hasClass("enable-autoplay");
  const enableLoop = $(this).hasClass("enable-loop");

  const swiper = new Swiper(this.querySelector(".swiper"), {
    modules: [Autoplay, EffectFade, Navigation],
    slidesPerView: 1,
    autoplay: enableAutoplay,
    loop: enableLoop,
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    speed: 2000,
    navigation: {
      prevEl: prevButton,
      nextEl: nextButton,
    },
    on: {
      slideChangeTransitionStart: function () {
        const activeSlide = $(swiper.slides[swiper.activeIndex]);

        gsap.set(".home-main-slider .js-text-fade", { opacity: 0, y: 50 });

        activeSlide.find(".js-text-fade").each(function () {
          gsap.to($(this), {
            opacity: 1,
            y: 0,
            duration: 0.7,
            stagger: 0.2,
            ease: "power1.out",
          });
        });
      },
    },
  });

  const initialSlide = $(swiper.slides[swiper.activeIndex]);
  initialSlide.find(".js-text-fade").each(function () {
    gsap.to($(this), {
      opacity: 1,
      y: 0,
      duration: 0.7,
      stagger: 0.2,
      ease: "power2.out",
    });
  });
});
